// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import KeyOutlinedSvg from "@fishx/icons-svg/es/asn/KeyOutlined";
import FishxIcon from '../components/FishxIcon';

var KeyOutlined = function KeyOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: KeyOutlinedSvg
  }));
};

KeyOutlined.displayName = 'KeyOutlined';
export default React.forwardRef(KeyOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/KeyOutlined.js
// module id = 3010
// module chunks = 0